import Dexie from 'dexie';

const db = new Dexie('OlFood');

// Tabelas com {Local} não existem na nuvem, e são normalmente usadas apenas para reexibição.

db.version(7).stores({
  produto: `
    ++id,
    proidnuvem,
    prodataalteracao,
    prodescricao,
    proidproduto,
    provalor,
    procodigointerno,
    proean,
    proidgrupo,
    proreferencia,
    grudescricao
  `,
  grupo: `
    ++id,
    grudataalteracao,
    gruidnuvem,
    gruidgrupo,
    grudescricao,
    grupermitefracionado,
    gruexportatablet
  `,
  processo: 'key'

});

db.open().then(function (db) {
  console.log('db | aberto: ', db);
}).catch (function (err) {
  console.log('db | erro: ', err)
});

// ORDERPRODUCAO?


export default db;
